import PropTypes from 'prop-types';
import FJMobileTextarea from '../../../common/components/FJMobileTextarea/FJMobileTextarea';
import FJLocalStore from '../../../store/FJLocalStore';
import FJTextToImageConstant from '../../../constants/FJTextToImageConstant';
import styles from './FJMobileTextToImageInput.module.less';
import FJTextToImageDataConfig from '../../../config/dataConfig/FJTextToImageDataConfig';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import { useState, useRef, useEffect } from 'react';
import FJConstant from '../../../constants/FJConstant';

const FJMobileTextToImageInput = props => {
    const { prompt, changePrompt, promptStatus, getInspire, showFooterModal } = props;

    const textareaRef = useRef(null);
    const [isExpand, setIsExpand] = useState(true);

    const _onAiPromptClick = e => {
        FJUtil.forbidEvent(e);
        showFooterModal({
            type: FJConstant.TEXT_TO_IMAGE_AI_PROMPT,
            hasMask: true,
        });
    };

    const _getInspire = e => {
        FJUtil.forbidEvent(e);
        getInspire();
    };
    const _expand = e => {
        FJUtil.forbidEvent(e);
        setIsExpand(true);
    };
    const _shrink = () => {
        if (textareaRef.current && textareaRef.current.getTextarea().value) {
            setIsExpand(false);
        }
    };
    useEffect(() => {
        if (!isExpand) return;
        FJUtil.addEvent(window, 'click', _shrink);
        return () => {
            FJUtil.removeEvent(window, 'click', _shrink);
        };
    }, [isExpand]);

    return (
        <>
            <div className={classNames(styles.box, isExpand ? styles.focus : '')}>
                <FJMobileTextarea
                    text={prompt}
                    onChange={changePrompt}
                    maxLength={FJTextToImageDataConfig.PROMPT_TEXT_LIMIT}
                    placeholder={FJLocalStore._(FJTextToImageDataConfig.PROMPT_PLACEHOLDER)}
                    aiPromptDisabled={promptStatus !== FJTextToImageConstant.NORMAL}
                    className={styles.textarea}
                    footerBottom={18}
                    // showLimit={true}
                    onFocus={() => {
                        setIsExpand(true);
                    }}
                    inputClassName={styles.textarea_input}
                    ref={textareaRef}
                />
                <div className={styles.footer}>
                    <div className={styles.footer_btn} onClick={_getInspire}>
                        {FJLocalStore._('inspire-me')}
                    </div>
                    <div className={styles.footer_btn} onClick={_onAiPromptClick}>
                        {FJLocalStore._('ai-prompt')}
                    </div>
                </div>
                <div
                    className={classNames(styles.single_line_text, !prompt ? styles.placeholder : '')}
                    onClick={_expand}
                >
                    {prompt || FJLocalStore._(FJTextToImageDataConfig.PROMPT_PLACEHOLDER)}
                </div>
            </div>
            {/* {renderAiPrompt()} */}
        </>
    );
};
FJMobileTextToImageInput.propTypes = {
    prompt: PropTypes.string,
    changePrompt: PropTypes.func,
    promptStatus: PropTypes.string,
    showUploadImageAsPromptModal: PropTypes.func,
    imageUrl: PropTypes.string,
    onCancel: PropTypes.func,
    getInspire: PropTypes.func,
    aiOptimizing: PropTypes.func,
    useImageAsPrompt: PropTypes.func,
    showFooterModal: PropTypes.func,
};
export default FJMobileTextToImageInput;
